import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import Button from '@mui/material/Button';

export const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: "/leaderboard",
      },
      authorizationParams: {
        prompt: "login",
      },
    });
  };

  return (
    <Button variant="outlined" size="small" onClick={handleLogin} sx={{ color: 'grey', borderColor: 'grey' }}>Login</Button>
  );
};
